export const ManagerAssessmentSkillSelectorOption = {
    ALL_SKILLS: 'AllSkills',
    WEAKEST_SKILLS: 'WeakestSkills',
    OLDER_THAN_SIX_MONTHS: 'OlderThanSixMonths',
    DO_NOT_ASSESS_SKILLS: 'DoNotAssessSkills',
} as const;

export type ManagerAssessmentSkillSelectorOptionValue =
    (typeof ManagerAssessmentSkillSelectorOption)[keyof typeof ManagerAssessmentSkillSelectorOption];
